import { last } from 'lodash-es';
import { NavigationGuard } from 'vue-router';

export default (function afterPermissionRedirectHandler(to, from, next) {
  const redirectMethod = last(to.matched)?.meta?.afterPermissionRedirect;

  if (typeof redirectMethod === 'function') {
    redirectMethod(to, from, next);
  } else {
    next();
  }
}) as NavigationGuard;
